import { useState, useEffect } from "react";
import { loadBillOfMaterialList } from "../services/billOfMaterialService";

const useBillOfMaterialList = () => {
    const [materialList, setMaterialList] = useState([]);    
    const [selectMaterial, setSelectedMaterial] = useState(null);   
    const [selectMaterialID, setSelectedMaterialID] = useState(null); 
    const [isMaterialListDataLoaded, setIsMaterialListDataLoaded] = useState(false);

    // Fetch department data
    const fetchMaterialList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadBillOfMaterialList(para);
            if (data && data.length > 0) {
                setMaterialList(data); 
                       
                setIsMaterialListDataLoaded(true);
                
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialListDataLoaded) {
            fetchMaterialList();
        }
    }, [isMaterialListDataLoaded]);

    // Function to load department based on selected ID
    const loadMaterialListByID = async (selectedID) => {
        await fetchMaterialList(selectedID);
    };

    return {
         materialList,         
         setMaterialList,
         selectMaterial,
         selectMaterialID,        
         loadMaterialListByID,
    };
};

export default useBillOfMaterialList;
